import React from "react";
import classNames from "classnames";

export interface FilterConfig {
  displayMode: "all" | "onlyMerchant";
  showNickname: boolean;
  showExtendedRows: boolean;
}

interface FilterBarProps {
  config: FilterConfig;
  onConfigChange: (config: Partial<FilterConfig>) => void;
  showNicknameOption?: boolean;
  showExtendedRowsOption?: boolean;
}

const Tooltip: React.FC<{ text: string; children: React.ReactNode }> = ({
  text,
  children,
}) => {
  const [show, setShow] = React.useState(false);
  return (
    <div
      className="relative flex items-center"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-0.5 bg-zinc-900 text-white text-[10px] rounded whitespace-nowrap z-50">
          {text}
          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-zinc-900 rotate-45" />
        </div>
      )}
    </div>
  );
};

const FilterBar: React.FC<FilterBarProps> = ({
  config,
  onConfigChange,
  showNicknameOption = false,
  showExtendedRowsOption = false,
}) => {
  const items: Array<{
    id: "extended" | "nickname" | "merchant";
    label: string;
    icon: string;
    active: boolean;
    onClick: () => void;
  }> = [];

  if (showExtendedRowsOption) {
    items.push({
      id: "extended",
      label: "40 dòng",
      icon: "📊",
      active: config.showExtendedRows,
      onClick: () =>
        onConfigChange({ showExtendedRows: !config.showExtendedRows }),
    });
  }

  if (showNicknameOption) {
    items.push({
      id: "nickname",
      label: "Nickname",
      icon: "👁️",
      active: config.showNickname,
      onClick: () =>
        onConfigChange({ showNickname: !config.showNickname }),
    });
  }

  items.push({
    id: "merchant",
    label: "Chỉ thương nhân",
    icon: "👑",
    active: config.displayMode === "onlyMerchant",
    onClick: () =>
      onConfigChange({
        displayMode:
          config.displayMode === "all" ? "onlyMerchant" : "all",
      }),
  });

  return (
    <div className="mt-2 flex items-center gap-1 px-2">
      {items.map((item) => (
        <Tooltip key={item.id} text={item.label}>
          <button
            onClick={item.onClick}
            className={classNames(
              "flex items-center justify-center w-6 h-6 rounded-full text-xs transition-all duration-200 cursor-pointer select-none",
              "active:scale-95",
              item.active
                ? "bg-emerald-600 text-white shadow-sm"
                : "bg-zinc-700 text-zinc-400 hover:text-zinc-300 hover:bg-zinc-600"
            )}
          >
            {item.icon}
          </button>
        </Tooltip>
      ))}
    </div>
  );
};

export default FilterBar;
